import React from 'react';
import ProductCanvas from './product-implant';

const ProductItem = ({ uniq, product, showImg }) => {
  return (
    <div className="card" key={uniq + '-' + product.Model}>
      {showImg ? <ProductCanvas {...product} /> : ''}
      <div className="content">
        <div className="header">
          {product['Product Code']} - {product['Model']}
        </div>
        <div className="description">
          <table className="ui very basic unstackable table product-card">
            <tbody>
              <tr>
                <td>
                  <strong>Volym:</strong> <span>{product['Volume']}</span>
                </td>
                <td>
                  <strong>Bredd:</strong> <span>{product['Width cm']}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Projektion cm:</strong>{' '}
                  <span>{product['Projection cm']}</span>
                </td>
                <td>
                  <strong>Höjd:</strong> <span>{product['Height cm']}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Sizer:</strong> <span>{product['Sizer']}</span>
                </td>
                <td>
                  <strong>Tabs:</strong> <span>{product['Tabs']}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Projektion:</strong>{' '}
                  <span>{product['Projection']}</span>
                </td>
                <td>
                  <strong>Yta:</strong> <span>{product['Surface']}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Lower Pole Arc A-B:</strong>{' '}
                  <span>{product['Lower Pole Arc A-B']}</span>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductItem;

/**
 * 
 * 
 *     <tr id={uniq + '-' + product.Model}>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td
        className="no-wrap"
        style={{ backgroundColor: 'rgb(231, 245, 253)', fontWeight: 'bolder' }}
      >
        {}
      </td>
      <td></td>
      <td></td>
      <td>{product['Projection']}</td>
      {showImg ? (
        <td>
          
        </td>
      ) : (
        ''
      )}
      <td className="no-wrap">{product.Model}</td>
      <td>{product['Surface']}</td>
 */
